import { activationClasses } from '../../common/consts';

export class OnePageMenuComponent {
  private panelOnePageMenuItems: HTMLElement[]; // data-panel-menu-level
  private anchorContents: HTMLElement[];

  constructor(
    private container: HTMLElement
  ) {
    this.panelOnePageMenuItems
        = Array.prototype.slice.call(this.container.querySelectorAll('[data-one-page-menu-item]'));
    this.anchorContents = Array.prototype.slice.call(document.querySelectorAll('[data-anchor-content]'));
  }
  public initialize(): void {
    let selectedMenuItem: string | undefined | null  = decodeURIComponent(window.location.hash.slice(1));
    this.panelOnePageMenuItems.forEach((popmi: HTMLElement) => {
      const itemAnchor: string | undefined | null = popmi?.querySelector('a')?.getAttribute('href');
      if (itemAnchor && itemAnchor ===  '#' + selectedMenuItem) {
        popmi.classList.add(activationClasses.active);
      }
      popmi.addEventListener('click', () => {
        this.panelOnePageMenuItems.forEach((popmic: HTMLElement) => {
          popmic.classList.remove(activationClasses.active);
        });
        popmi.classList.add(activationClasses.active);
        selectedMenuItem = popmi?.querySelector('a')?.getAttribute('href')?.replace('#', '');
      });
    });
    const contentNavigateParams= this.anchorContents.map((anchorContent: HTMLElement) => {
      const rect = anchorContent.getBoundingClientRect()
      return {contentNavigateValue: anchorContent.getAttribute('id'), rect};
    })
    window.addEventListener('scroll', () => {

      this.anchorContents.forEach((anchorContent: HTMLElement, index: number) => {
        const rect = anchorContent.getBoundingClientRect();
        const {top: topNavigate} = this.container.getBoundingClientRect();
        const {top: topContent, height: heightContent} =  rect;
        const currentElementNavigate =  this.panelOnePageMenuItems.find(
            (popmi: HTMLElement) => popmi.querySelector('a')?.getAttribute('href')
                === '#' + anchorContent.getAttribute('id')
        );

        if (
          this.panelOnePageMenuItems[index]
          && this.panelOnePageMenuItems[index]
              .querySelector('a')?.getAttribute('href') !== '#' + selectedMenuItem
        ) {
          this.panelOnePageMenuItems[index].classList.remove(activationClasses.active)
        }
        if (
          contentNavigateParams
            .some(contentNavigateParam => !(
              contentNavigateParam.rect.top
              + heightContent
              >= topNavigate &&
              (contentNavigateParam.rect.height + contentNavigateParam.rect.top) - topNavigate * 2
              <
              contentNavigateParam.rect.height
            )
          )
        ) {
          this.panelOnePageMenuItems[index].classList.remove(activationClasses.active)
        } // тут можно попробовать доработать подумать с find
        if (
          topContent + heightContent >= topNavigate && (topContent + heightContent) - topNavigate * 2 < heightContent
        )  {
          if (!currentElementNavigate?.classList.contains(activationClasses.active)) {
            currentElementNavigate?.classList.add(activationClasses.active);
          }
          selectedMenuItem = anchorContent.getAttribute('id');
        }
      });
    });
  }
}
